// removed by extract-text-webpack-plugin
module.exports = {"markdownWrapper":"markdownWrapper--cce6c"};